import type {
  AddOn,
  FixedCharge,
  LotteryQuery,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export type LotteryConfig = LotteryQuery['lottery']['currentConfig']

const getNumberOfPlays = (config?: LotteryConfig) => config?.allowedPlays?.at(-1) ?? 1

export const getInitialSelectedAddOns = (config?: LotteryConfig) =>
  config?.addOns.filter(isNotPerPlay).map((addOn) => ({
    name: addOn.name,
    value: addOn.mandatory ? addOn.options[0] : '',
  })) ?? []

export const getInitialPerPlayAddOns = (config?: LotteryConfig) => {
  if (!config) return []

  const perPlayAddOn = config.addOns.find(isPerPlay)
  if (!perPlayAddOn) return []

  return Array.from({ length: getNumberOfPlays(config) }, () => ({
    name: perPlayAddOn.name,
    value: perPlayAddOn?.options?.at(0) ?? '',
  }))
}

export const getInitialSelectedNumbers = (config?: LotteryConfig) =>
  Array.from({ length: getNumberOfPlays(config) }, () => ({
    isQuickPick: false,
    numbers: config?.numbers.map<number[]>(() => []) ?? [],
  }))

export const getInitialStake = (config?: LotteryConfig) => {
  if (!config?.stakes) return ''
  return config.stakes[0].price
}

export const isFixedCharge = (charge: unknown): charge is FixedCharge =>
  (charge as FixedCharge)?.value !== undefined

export const isPerPlay = (addOn: Partial<AddOn>) => addOn.perPlay
export const isNotPerPlay = (addOn: Partial<AddOn>) => !isPerPlay(addOn)
